import { Helmet } from 'react-helmet-async';

interface ProductSchemaProps {
  name: string;
  description: string;
  image?: string;
  url: string;
  brand?: string;
  category?: string;
  ratingValue?: string;
  ratingCount?: string;
}

export const ProductSchema = ({
  name,
  description,
  image,
  url,
  brand = "RSA Tech Group",
  category = "Software",
  ratingValue = "4.8",
  ratingCount = "45"
}: ProductSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": name,
    "description": description,
    "url": url,
    "applicationCategory": category,
    "operatingSystem": "All",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": ratingValue,
      "ratingCount": ratingCount,
      "bestRating": "5",
      "worstRating": "1"
    },
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "price": "0",
      "priceCurrency": "USD",
      "priceValidUntil": "2027-12-31",
      "seller": {
        "@type": "Organization",
        "name": brand
      }
    },
    "publisher": {
      "@type": "Organization",
      "name": brand,
      "url": "https://rsatech.com"
    },
    ...(image && { "image": image })
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

// Pre-configured product schemas for RSA Tech Group products
export const LeorixAISchema = () => (
  <ProductSchema
    name="Leorix AI"
    description="Autonomous enterprise brain for intelligent data orchestration. Leorix AI serves as your organization's cognitive core -connecting, analyzing, and acting on enterprise data in real-time."
    url="https://rsatech.com/leorix-ai"
    category="BusinessApplication"
  />
);

export const PostwyseSchema = () => (
  <ProductSchema
    name="Postwyse"
    description="AI-powered content intelligence engine that transforms how organizations create, manage, and optimize content across channels."
    url="https://rsatech.com/postwyse"
    category="BusinessApplication"
  />
);

export const PromptProSchema = () => (
  <ProductSchema
    name="Prompt Pro"
    description="Professional IDE for LLM prompt engineering. Design, test, and deploy production-ready prompts with enterprise-grade security."
    url="https://rsatech.com/promptpro"
    category="DeveloperApplication"
  />
);

export const TradershubSchema = () => (
  <ProductSchema
    name="Tradershub"
    description="Real-time market intelligence workspace providing AI-driven insights for financial decision-making."
    url="https://rsatech.com/tradershub"
    category="FinanceApplication"
  />
);
